module.exports = __webpack_public_path__ + "img/pocketid.jpg_w545.5b7a52cf.jpg";